import React from "react";

export const ConnectionsIcon = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.7002 8.34571L14 11.6456L10.7002 14.9454L9.75733 14.0026L11.448 12.3117L2.66667 12.3122V10.9789L11.448 10.9784L9.75733 9.28851L10.7002 8.34571ZM5.29983 1.67905L6.24264 2.62186L4.552 4.31171L13.3333 4.31221V5.64555L4.552 5.64505L6.24264 7.33591L5.29983 8.27871L2 4.97888L5.29983 1.67905Z"
        fill="currentColor"
      />
    </svg>
  );
};
